import {FETCH_ARTICLES} from '../actions/types';
import States from "../states";



export default function(state = States, action){
    switch(action.type){
        case FETCH_ARTICLES:
            return {
                ...state,
                datas: action.payload
            };
        default:
            return state;
    }
}